const routes = require("./routes/routes");
const dateLoc = require("./dateLoc/es_mx");

module.exports = {
    routes,
    dateLoc
};
